<div class="w-full flex flex-col pr-2 pl-[1px] py-[1px] gap-2">
  @for (item of notifications; track item.id) {
    <div class="notification shadow-e1 p-4 flex flex-col gap-3 rounded-[1rem]"
         [class.is-read]="item.isRead"
         [class.is-loading]="isLoading(item)"
         [class.type-info]="item.type === 'info'"
         [class.type-success]="item.type === 'success'"
         [class.type-warning]="item.type === 'warning'"
         [class.type-error]="item.type === 'error'">

      <div class="flex gap-2 flex-row w-full">
        <button (click)="toggleExpanded(item)" [disabled]="!expandable" class="notification-title-btn cd-text-b3 font-medium my-auto text-left">
          {{ item.name }}
        </button>
        <div class="ml-auto flex flex-row gap-2 items-center">
          @if (isLoading(item)) {
            <img alt="Loading" class="h-4 loader-icon" src="/assets/icons/feather/loader.svg">
          }
          @if (showClose) {
            <button (click)="handleClose(item)" [disabled]="isLoading(item)" class="btn mb-auto !p-1">
              <img alt="Close" class="h-4" src="/assets/icons/feather/x.svg">
            </button>
          }
        </div>
      </div>

      @if (isExpanded(item)) {
        @if (item.description) {
          <span class="cd-text-b3 text-neutral-400">{{ item.description }}</span>
        }

        @if (showActions) {
          <div class="flex lg:flex-row gap-3">
            @for (action of (item.actions || []); track action.slug; let i = $index) {
              <button (click)="handleAction(item, action)" [disabled]="isLoading(item)" [class.btn-neutral-outline]="!!i" [class.btn-primary]="!i" class="btn">
                <span class="cd-text-b3 font-medium">{{ action.name }}</span>
              </button>
            }
          </div>
        }
      }
    </div>
  }
</div>
